import { render, staticRenderFns } from "./ForexCurrencyPairCurrencies.vue?vue&type=template&id=b8cfca40"
import script from "./ForexCurrencyPairCurrencies.vue?vue&type=script&lang=js"
export * from "./ForexCurrencyPairCurrencies.vue?vue&type=script&lang=js"
import style0 from "./ForexCurrencyPairCurrencies.vue?vue&type=style&index=0&id=b8cfca40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports